import axios from 'axios'
export const HOST_NAME = (window as any)._IP || ''
const BASE_PATH = '/api/jh/znys'

export enum PATH {
  ORG_PATH = '/receive/orgApply', // 机构表单申请
  PERSON_PATH = '/receive/personApply', // 自然人表单申请
  LIST_BY_PATH = '/dict/listByTypes', // 证件类型
  UP_PATH = '/file/upload', // 机构表单申请
  UP_REVIEW = '/sample/uploadReview', // 机构表单申请
  SAVE_PATH = '/sample/save', // 机构表单申请
  submitApply = '/receive/submitApply', // 获取登录信息
  USER_INFO_PATH = '/auth/getUserInfo', // 获取用户信息
  IMG_PATH = '/file/uploadImage', // 获取用户信息
  DOWN_LOAD_PATH = '/file/download', // 获取用户信息
  UPLOAD = '/sample/upload',
  GET_APP_CARD = '/sample/getByApplicantIdCard',
  GET_BY_ID_CARD = '/reviewProve/getByIdCard',
  FILE_LIST = '/reviewProve/list',
}

export function orgApplyApi(param: any = {}): Promise<any> {
  param.type = '1'
  return axios.post(PATH.ORG_PATH, param)
}
export function personApplyApi(param: any = {}): Promise<any> {
  param.type = '1'
  return axios.post(PATH.PERSON_PATH, param)
}

export function listByTypesApi(params: any = {}): Promise<any> {
  return axios.post(PATH.LIST_BY_PATH, params)
}

export function uploadApi(params: any = {}): Promise<any> {
  return axios.post(PATH.UP_PATH, params)
}

export function uploadReviewApi(params: any = {}): Promise<any> {
  return axios.post(PATH.UP_REVIEW, params)
}

export function imgUploadApi(params: any = {}): Promise<any> {
  return axios.post(PATH.IMG_PATH, params)
}

export function saveApi(params: any = {}): Promise<any> {
  params.type = '1'
  return axios.post(PATH.SAVE_PATH, params)
}

export function uploadSubmitApi(params: any = {}): Promise<any> {
  return axios.post(PATH.UPLOAD, params)
}

export function submitApplyApi(params: any = {}): Promise<any> {
  return axios.post(`${PATH.submitApply}?uuid=${params.uuid}`, {id:params.id})
}

// 获取用户信息
export function getUserInfoApi(params: any = {}): Promise<any> {
  return axios.get(PATH.USER_INFO_PATH, { params })
}

export function getByApplicantIdCardApi(params: any = {}): Promise<any> {
  params.type = '1'
  return axios.post(PATH.GET_APP_CARD, params)
}

export function getByIdCardApi(params: any = {}): Promise<any> {
  return axios.post(PATH.GET_BY_ID_CARD, params)
}

export function fileListApi(params: any = {}): Promise<any> {
  params.type = '1'
  return axios.get(PATH.FILE_LIST, { params })
}

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
      config.url = BASE_PATH + config.url
    } else {
      config.url = HOST_NAME + config.url
    }
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  function ({ data }) {
    return data
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)
